import { createFileRoute } from "@tanstack/react-router";
import { FjernAvtalePage } from "@/features/bestillinger/FjernAvtalePage";

export const Route = createFileRoute("/_app/_subheader/fjern-avtale/")({
  component: FjernAvtalePage,
});
